const comments = [
  {
    name: '吃瓜小能手',
    time: '2小时前',
    text: '这个平台太绝了！每天上班第一件事就是打开吃瓜黑料爆料网，信息更新特别快，而且条理清晰，比我自己在微博上到处找方便太多了。',
    likes: 328,
  },
  {
    name: '娱乐圈观察员',
    time: '5小时前',
    text: '说实话现在八卦信息太乱了，但这里整理得确实不错，每条瓜都有来源标注，不是那种随手编的假料。深度深扒栏目特别精彩，推荐给所有吃瓜群众。',
    likes: 256,
  },
  {
    name: '匿名瓜友9527',
    time: '8小时前',
    text: '作为一个资深吃瓜人，我表示这个网站真的很良心。尤其是瓜料合集功能，按主题分类太方便了，想回顾哪个明星的黑料直接找专题就行。',
    likes: 189,
  },
  {
    name: '爆料一线牵',
    time: '12小时前',
    text: '最让我安心的是匿名投稿机制，我之前爆了一个小料，完全没有泄露个人信息。希望平台越做越好，让更多真相被看见！',
    likes: 145,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            瓜友热评
          </h2>
          <p className="text-foreground-500 text-sm">来自真实读者的声音</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {comments.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center text-secondary-700 font-bold text-sm">
                  {item.name.charAt(0)}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                "{item.text}"
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes} 人觉得有用</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}